import type { AppRoute } from "@/lib/routing";

// Owner: C5 (bench, labels and devices). Bench pages work on a tablet beside the balance
// (.cursor/rules/ux-heuristics-accessibility.mdc, bench mode).
export const routes: AppRoute[] = [
  {
    path: "/bench",
    lazy: async () => ({ Component: (await import("./pages/BatchesPage")).BatchesPage }),
    handle: { title: "Bench", keywords: ["batches", "trials", "weighing", "dilutions", "balance"] },
  },
  {
    path: "/bench/new",
    lazy: async () => ({ Component: (await import("./pages/NewBatchPage")).NewBatchPage }),
    handle: { title: "New batch", keywords: ["trial", "dilution", "weigh", "make", "plan"] },
  },
  {
    path: "/bench/ladders",
    lazy: async () => ({ Component: (await import("./pages/LaddersPage")).LaddersPage }),
    handle: { title: "Ladders", keywords: ["dose", "blind", "series", "variants"] },
  },
  {
    path: "/bench/:id",
    lazy: async () => ({ Component: (await import("./pages/BatchPage")).BatchPage }),
    handle: { title: "Batch" },
  },
  {
    path: "/evaluations",
    lazy: async () => ({ Component: (await import("./pages/EvaluationsPage")).EvaluationsPage }),
    handle: { title: "Evaluations", keywords: ["smell journal", "notes", "ratings", "blind"] },
  },
  {
    path: "/reminders",
    lazy: async () => ({ Component: (await import("./pages/RemindersPage")).RemindersPage }),
    handle: { title: "Reminders", keywords: ["resmell", "shelf life", "retest", "reorder", "calendar"] },
  },
];
